'use client';

import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';

import { faqs } from '@/src/constants/FAQs';
import { sendAnalyticsData } from '@/src/utils/analytics';

import type { IFAQ, IFAQTags } from '../home.interface';
import { FAQ } from './FAQ';

export const FAQs = ({ tag }: IFAQTags) => {
  return (
    <div className="container mx-auto px-6 py-16 text-center md:px-16 2xl:px-24">
      <div className="py-8 text-center text-[28px] font-medium text-[#3D3E40] md:text-4xl">
        Frequently Asked Questions
      </div>
      <div className="md:mt-6">
        {faqs.map((faq: IFAQ, index: number) => (
          <FAQ key={index} faq={faq} _tag={tag} />
        ))}
      </div>

      <div className="mt-8 flex flex-col items-center justify-center gap-y-1 md:flex-row md:gap-x-2 ">
        <Link
          href="/faqs"
          className="flex cursor-pointer items-center gap-x-1 self-center rounded-lg border-2 border-solid border-[#318AE5] p-4 text-[16px] font-medium !text-[#318AE5] hover:!bg-[#318AE5] hover:!text-white"
          onClick={() => sendAnalyticsData('VIEW_ALL_FAQS_CLICKED')}
        >
          <span>View all FAQs</span>{' '}
          <ChevronRightIcon className="stroke-3 h-4 w-4" />
        </Link>
        <Link
          href="/contact-us"
          className="cursor-pointer px-6 text-[16px] font-medium !text-[#318AE5] hover:!text-[#2B81D9]"
          onClick={() => sendAnalyticsData('CONTACT_US_CLICKED')}
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
};
